module.exports = __webpack_public_path__ + "img/P2-B8.a0603aa9.svg";